export default __webpack_public_path__ + "static/media/northCarolinaMap.4ffce4fe.png";